module.exports = __webpack_public_path__ + "static/partner1-3ef438fcad6fcdb5605ee3677227d365.png";